import React from 'react';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { DaButton } from '@paygreen/paygreen-ui';
import IconByName from '../../utils/IconByName';

const EditButton = ({
    t,
    onClick,
    buttonSize,
    buttonStyle,
    colorStatus,
    children,
    dataCy,
    icon,
}) => (
    <button type="button" onClick={onClick} data-cy={dataCy}>
        <DaButton
            buttonSize={buttonSize}
            buttonStyle={buttonStyle}
            colorPallet="status"
            colorStatus={colorStatus}
            icon={<IconByName name={icon} />}
        >
            {children}
        </DaButton>
    </button>
);

EditButton.propTypes = {
    onClick: PropTypes.func,
    buttonSize: PropTypes.string,
    buttonStyle: PropTypes.string,
    colorStatus: PropTypes.string,
    icon: PropTypes.string,
    /**
     * Id for Cypress tests
     */
    dataCy: PropTypes.string,
};

EditButton.defaultProps = {
    colorStatus: 'default',
    buttonStyle: 'fill',
    buttonSize: 'md',
    icon: 'PenIcon',
};

export default withTranslation('common')(EditButton);
